module.exports = __webpack_public_path__ + "img/herb-chives-190x100.aca4e1c0.jpg";